class WellController {
    constructor() {
        
        this.setOtherSlider2();
        this.setOwnersVoiceSlider();
    }


    setOtherSlider2() {
        let options = {
            loop: false,
            spaceBetween: (window.UA.isSP) ? 24 : 32,
            slidesPerView: 'auto',
            navigation: {
                nextEl: '#style-detail__other-slide-next2',
                prevEl: '#style-detail__other-slide-prev2',
            },
            scrollbar: {
                el: '#style-detail__other-slide-bar2',
                draggable: false,
            },
            touchAngle: 20,
            speed: 800,
            lazy: {
                loadPrevNext: true,
            },
        };

        let otherSlider = new Swiper('#js-style-detail__other-slide2', options);
        otherSlider.update();
    }
    setOwnersVoiceSlider() {
        let slideCount = document.querySelectorAll('#js-ownersvoice-slide .swiper-slide').length;
        if (window.UA.isSP) {
            // スマホ幅のとき
            if (slideCount >= 2) {
                let options = {
                    loop: false,
                    loopAdditionalSlides: 1,
                    loopFillGroupWithBlank: false,
                    centeredSlides: false,
                    spaceBetween: 24,
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: '#js-ownersvoice-next',
                        prevEl: '#js-ownersvoice-prev',
                    },
                    scrollbar: {
                        el: '#js-ownersvoice-bar',
                        draggable: false,
                    },
                    touchAngle: 20,
                    speed: 800,
                };
                let otherSlider = new Swiper('#js-ownersvoice-slide', options);
                otherSlider.off('resize');
            } else {
                document.querySelector('#js-ownersvoice-slide').classList.add('min-slide');
                document.querySelector('#js-ownersvoice-nav').classList.add('min-slide-nav');
            }
        } else {
            // PC幅のとき
            if (slideCount >= 4) {
                let options = {
                    loop: false,
                    loopAdditionalSlides: 1,
                    loopFillGroupWithBlank: false,
                    centeredSlides: false,
                    spaceBetween: 32,
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: '#js-ownersvoice-next',
                        prevEl: '#js-ownersvoice-prev',
                    },
                    scrollbar: {
                        el: '#js-ownersvoice-bar',
                        draggable: false,
                    },
                    touchAngle: 20,
                    speed: 800,
                };
                let otherSlider = new Swiper('#js-ownersvoice-slide', options);
            } else {
                document.querySelector('#js-ownersvoice-slide').classList.add('min-slide');
                document.querySelector('#js-ownersvoice-nav').classList.add('min-slide-nav');
            }
        }
    }
}

export default WellController;